import { createContext, useContext, useReducer } from 'react';
import axios from 'axios';

const ShareContext = createContext();

const shareReducer = (state, action) => {
  switch (action.type) {
    case 'SET_SHARED_TASKS':
      return {
        ...state,
        sharedWithMe: action.payload
      };
    case 'ADD_SHARE':
      return {
        ...state,
        shares: [...state.shares, action.payload]
      };
    case 'UPDATE_SHARE':
      return {
        ...state,
        shares: state.shares.map(share =>
          share.taskId === action.payload.taskId ? action.payload : share
        )
      };
    case 'REMOVE_SHARE':
      return {
        ...state,
        shares: state.shares.filter(share => 
          share.taskId !== action.payload.taskId ||
          !share.sharedWith.some(s => s.userId === action.payload.userId)
        )
      };
    default:
      return state;
  }
};

export const ShareProvider = ({ children }) => {
  const [state, dispatch] = useReducer(shareReducer, {
    shares: [],
    sharedWithMe: []
  });

  // Condividi un task
  const shareTask = async (taskId, userEmails, permissions) => {
    try {
      const res = await axios.post('/api/share', {
        taskId,
        userEmails,
        permissions
      });
      dispatch({ type: 'ADD_SHARE', payload: res.data });
    } catch (err) {
      throw err;
    }
  };

  // Ottieni i task condivisi con me
  const getSharedWithMe = async () => {
    try {
      const res = await axios.get('/api/share/shared-with-me');
      dispatch({ type: 'SET_SHARED_TASKS', payload: res.data });
    } catch (err) {
      throw err;
    }
  };

  // Aggiorna i permessi
  const updatePermissions = async (taskId, userId, permissions) => {
    try {
      const res = await axios.put(`/api/share/${taskId}/permissions`, {
        userId,
        permissions
      });
      dispatch({ type: 'UPDATE_SHARE', payload: res.data });
    } catch (err) {
      throw err;
    }
  };

  // Rimuovi la condivisione
  const removeShare = async (taskId, userId) => {
    try {
      await axios.delete(`/api/share/${taskId}/user/${userId}`);
      dispatch({
        type: 'REMOVE_SHARE',
        payload: { taskId, userId }
      });
    } catch (err) {
      throw err;
    }
  };

  return (
    <ShareContext.Provider
      value={{
        shares: state.shares,
        sharedWithMe: state.sharedWithMe,
        shareTask,
        getSharedWithMe,
        updatePermissions,
        removeShare
      }}
    >
      {children}
    </ShareContext.Provider>
  );
};

export const useShareContext = () => useContext(ShareContext);